import * as React from "react"
import { graphql } from "gatsby"
import PageGeneral from "./subtemplates/subtemplate_general";

export const query = graphql`
  query($pwid: Int!) {
    sitePage(context: { pwid: { eq: $pwid } }) {
      context {
        seo_image {
          url
        }
        seo_no_indexable
        seo_header_no_h1
        content {
          type
          data {
            title
            url
            title_tipo
            texto_corto1
            texto_corto2
            texto_sin_formato1
            texto_con_formato1
            descarga
            checkbox1
            checkbox2
            numero1
            numero2
            styles
            htmltag
            blocks {
              type
              title
              url
              align
              texto_corto1
              texto_con_formato1
              texto_sin_formato1
              image_mobile {
                aspectratio
                base64
                description
                height
                url
                url220
                url440
                url880
                url980
                url1200
                url2000
                url220webp
                url440webp
                url880webp
                url980webp
                url1200webp
                url2000webp
                width
              }
              image {
                aspectratio
                base64
                description
                height
                url
                url220
                url440
                url880
                url980
                url1200
                url2000
                url220webp
                url440webp
                url880webp
                url980webp
                url1200webp
                url2000webp
                width
              }
            }
          }
        }
        seo_title
        seo_description
        langs {
          code
          current
          url
        }
        title
        donde_comprar_slug
        donde_comprar_pais
        donde_comprar_ciudad
        parent_page {
          title
          ruta
        }
      }
    }
  }
`
const PageLegalTemplate = props => <PageGeneral {...props} />
export default PageLegalTemplate
